import { Theme } from '@mui/material';
import { ThemeOptions } from '@mui/material/styles/createTheme';
import { is, mergeDeepWithKey, mergeRight } from 'ramda';

const mergeThemeOptions = (leftTheme: ThemeOptions, rightTheme: ThemeOptions): ThemeOptions => {
  const deepMergeResults = mergeDeepWithKey<ThemeOptions, ThemeOptions>(
    (key, left, right) => {
      // Making an assumption that all functions will be within styleOverrides.
      const isLeftFunc = is(Function, left);
      const isRightFunc = is(Function, right);
      if (isLeftFunc || isRightFunc) {
        return ({ theme, ownerState }: { theme: Theme; ownerState: Record<string, unknown> }) => {
          const leftResults = isLeftFunc ? left({ theme, ownerState }) : left;
          const rightResults = isRightFunc ? right({ theme, ownerState }) : right;
          return mergeRight(leftResults, rightResults);
        };
      }
      return right;
    },
    leftTheme,
    rightTheme
  ) as ThemeOptions;
  return deepMergeResults;
};

export { mergeThemeOptions };
